import { action, computed, makeObservable, observable } from 'mobx';

import { InvoiceFileType } from '../services/ApiService';

import { ISsoStore } from './SsoStore';

export default class EmployeeUsagesStore {
  @observable
  public hasCheckedUsages = false;
  @observable
  public restrictedFiles: InvoiceFileType[] = [];

  constructor(private ssoStore: ISsoStore) {
    makeObservable(this);
  }

  @computed
  public get hasEmployeeCheckedUsages(): boolean {
    return this.hasCheckedUsages;
  }

  @action
  public changeHasCheckedUsagesTrueAndDontShowNotice(): void {
    this.hasCheckedUsages = true;
    this.restrictedFiles = [];
  }

  @computed
  public get restrictedEmployeeFile(): InvoiceFileType {
    return this.restrictedFiles[this.restrictedFiles.length - 1];
  }

  @computed
  public get showEmployeeInvoiceUsagesHeaderNotice(): boolean {
    return this.ssoStore.isDealer && this.restrictedFiles.length > 0;
  }

  @action
  public addRestrictedEmployeeFiles(invoiceFileType: InvoiceFileType): void {
    if (this.ssoStore.isDealer && !this.hasCheckedUsages && invoiceFileType === 'USAGES_CSV') {
      if (!this.restrictedFiles.includes('USAGES_CSV')) {
        this.restrictedFiles.push('USAGES_CSV');
      }
    }
  }

  public usagesDownloadRestrictedForDealer(invoiceFileType: InvoiceFileType): boolean {
    return this.ssoStore.isDealer && invoiceFileType === 'USAGES_CSV' && !this.hasCheckedUsages;
  }
}
